var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ct-alert-msg",class:['alert-color-' + _vm.color]},[_c('span',[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }